import { Injectable } from '@angular/core';
import { FieldType } from 'src/app/core/models/field-types/field-type';
import { FieldTypeService } from 'src/app/core/services/field-types/field-type.service';
import { AutoTransform } from 'src/app/core/types/field-types/auto-transform';
import { DataType } from 'src/app/core/types/field-types/data-type';
import { InputType } from 'src/app/core/types/field-types/input-type';

@Injectable({
  providedIn: 'root'
})
export class CommonFieldtypesService {

  constructor(private fieldTypeService: FieldTypeService) {
  }


  initializeFieldTypes() {
    this.fieldTypeService.registerFieldTypes(FIELD_TYPES);
  }
}

const FIELD_TYPES: FieldType[] = [
  {
    id: 'date',
    description: 'Date',
    dataType: DataType.DATE,
    inputType: InputType.TEXT,
    transform: AutoTransform.UPPER_CASE,
    icon: 'calendar'
  },
  {
    id: 'text',
    description: 'Text',
    dataType: DataType.STRING,
    inputType: InputType.TEXT
  },
  {
    id: 'compute',
    description: 'Computable expression',
    dataType: DataType.STRING,
    inputType: InputType.TEXT,
    transform: AutoTransform.COMPUTE
  },  
  {
    id: 'email',
    description: 'Email',
    dataType: DataType.STRING,
    inputType: InputType.TEXT
  },
  {
    id: 'password',
    description: 'Password',
    dataType: DataType.STRING,
    inputType: InputType.PASSWORD,
  },
  {
    id: 'companyId',
    description: 'Company Id',
    dataType: DataType.STRING,
    inputType: InputType.TEXT,
    permittedChars: /[A-Za-z0-9]/,
    transform: AutoTransform.UPPER_CASE
  },
  {
    id: 'companyName',
    description: 'Company Name',
    dataType: DataType.STRING,
    inputType: InputType.TEXT
  },
  {
    id: 'gstNumber',
    description: 'GST Number',
    dataType: DataType.STRING,
    inputType: InputType.TEXT,
    permittedChars: /[0-9A-Za-z]/,
    transform: AutoTransform.UPPER_CASE
  },
  {
    id: 'employeeId',
    description: 'Employee Id',
    dataType: DataType.STRING,
    inputType: InputType.TEXT,
    permittedChars: /[0-9A-Za-z-]/,
    transform: AutoTransform.UPPER_CASE
  },
  {
    id: 'employeeEmail',
    description: 'Email',
    dataType: DataType.STRING,
    inputType: InputType.TEXT
  },  
  {
    id: 'country',
    description: 'Country',
    dataType: DataType.STRING,
    inputType: InputType.TEXT
  },
  {
    id: 'pinCode',
    description: 'PinCode',
    dataType: DataType.STRING,
    inputType: InputType.TEXT,
    permittedChars: /[0-9A-Za-z ]/,
    transform: AutoTransform.UPPER_CASE
  },
  {
    id: 'airline',
    description: 'Airline',
    dataType: DataType.STRING,
    inputType: InputType.TEXT,
    permittedChars: /[0-9A-Za-z-]/,
    transform: AutoTransform.UPPER_CASE
  },
  {
    id: 'airport',
    description: 'Airport Code',
    dataType: DataType.STRING,
    inputType: InputType.TEXT,
    permittedChars: /[0-9A-Za-z-]/,
    transform: AutoTransform.UPPER_CASE
  },
  {
    id: 'destination-country',
    description: 'Destination Country',
    dataType: DataType.STRING,
    inputType: InputType.TEXT
  },
  {
    id: 'destination-city',
    description: 'Destination City',
    dataType: DataType.STRING,
    inputType: InputType.TEXT
  },
  {
    id: 'hotelName',
    description: 'Hotel Name',
    dataType:DataType.STRING,
    inputType: InputType.TEXT
  },
  {
    id: 'stationCode',
    description: 'Station Code',
    dataType: DataType.STRING,
    inputType: InputType.TEXT,
    permittedChars: /[0-9A-Za-z-]/,
    transform: AutoTransform.UPPER_CASE
  },
  {
    id: 'flightNumber',
    description: 'Flight Number',
    dataType: DataType.STRING,
    inputType: InputType.TEXT,
    permittedChars: /[0-9A-Za-z-]/,
    transform: AutoTransform.UPPER_CASE
  },
  {
    id: 'pnr',
    description: 'Airport Code',
    dataType: DataType.STRING,
    inputType: InputType.TEXT,
    permittedChars: /[0-9A-Za-z-]/,
    transform: AutoTransform.UPPER_CASE
  },
  {
    id: 'time-field',
    description: 'Time Field',
    dataType: DataType.STRING,
    inputType: InputType.TEXT,
    maxlength: 2,
    permittedChars: /[0-9]/,
    transform: AutoTransform.UPPER_CASE
  },
  {
    id: 'busStation',
    description: 'Bus Station',
    dataType: DataType.STRING,
    inputType: InputType.TEXT
  },
];
